import { cx } from '@twind/core';
import OstroDynamicContent from 'app/components/OstroDynamicContent';

import useContactFormTracking from '../hooks/useContactFormTracking';
import { FormItemCheckbox } from '../types';

type Props = { item: FormItemCheckbox; isSubmitted: boolean; contactFormSlug?: string };

export function ContactFormCheckbox({ item, isSubmitted, contactFormSlug }: Props) {
  const hasErrors = item.errors?.length;
  const { captureContactFormCheckbox } = useContactFormTracking();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    captureContactFormCheckbox({
      fieldName: item.event_name,
      checked: e.target.checked,
      required: item.required,
      text: item.label,
      contactFormSlug,
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="flex gap-3 items-start cursor-pointer">
        <input
          type="checkbox"
          name={item.ref_id}
          defaultChecked={item.value === 'true'}
          required={item.required}
          className={cx(
            'accent-[#000000] shrink-0 h-4 w-4 mt-1',
            isSubmitted && hasErrors ? 'outline-[#FF3323]' : 'outline-typography-divider'
          )}
          onChange={handleChange}
        />
        <OstroDynamicContent
          dangerouslySetInnerHTML={{ __html: item.label }}
          className="text-sm [&_p]:mb-0"
        />
      </label>
      {hasErrors && item.errors?.length ? (
        <div className="text-xs text-[#FF3323]">{item.errors?.join(', ')}</div>
      ) : null}
    </div>
  );
}
